















































import { Component } from 'vue-property-decorator';

import BaseView from '@/views/BaseView.vue';
import ExamFooter from '@/components/ExamFooter.vue';
import ExamNav from '@/components/ExamNav.vue';
import IndicatorModal from '@/components/IndicatorModal.vue';

import * as StringUtil from '@/common/StringUtil';

import RepositoryFactory from '@/repository/RepositoryFactory';

import DesignResource from '@/models/exam/DesignResource';

@Component(
  {
    components: {
      'e-footer': ExamFooter,
      'e-nav': ExamNav,
      'e-indicator': IndicatorModal,
    },
  },
)
export default class ExamFinish extends BaseView {
  private entryCode: string;

  private resultCode: string;

  private judgementType = '';

  private isMaintenance = false;

  private isIndicatorDisplay = false;

  private resources = {
    EXAM_END_IMG: new DesignResource(),
  };

  private async mounted() {
    this.isIndicatorDisplay = true;

    this.initStaticScripts();
    const { rank, entry, result } = this.$route.query;
    this.entryCode = String(entry);
    this.resultCode = String(result);

    this.getExamInfo();
    await this.getExamRankInfo(String(rank));
    this.isIndicatorDisplay = false;
  }

  /**
   * 検定情報の取得
   */
  private getExamInfo() {
    try {
      const ExamRepository = RepositoryFactory.get().exam;
      ExamRepository.getExam().then((response) => {
        if (response.status === 200) {
          // eslint-disable-next-line prefer-destructuring
          const data = response.data;

          // デザインリソース
          if (data.resources !== undefined) {
            data.resources.forEach((resource: any) => {
              const key = resource.display_place_key;
              if (key in this.resources) {
                const tmp = new DesignResource();
                tmp.displayPlaceKey = resource.display_place_key;
                tmp.displayText = StringUtil.isEmpty(resource.display_text) ? '' : resource.display_text;
                tmp.cssClassName = StringUtil.isEmpty(resource.css_class_name) ? '' : resource.css_class_name;
                tmp.resourceUri = StringUtil.isEmpty(resource.resource_uri) ? '' : resource.resource_uri;
                tmp.resourceFileName = StringUtil.isEmpty(resource.resource_file_name) ? '' : resource.resource_file_name;
                tmp.alternativeText = StringUtil.isEmpty(resource.alternative_text) ? '' : resource.alternative_text;
                // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
                // @ts-ignore
                this.resources[key] = tmp;
              }
            });
          }
        }
      }).catch(() => {
        this.$router.replace(this.paths.TOP);
      });
    } catch (_) {
      this.$router.replace(this.paths.TOP);
    }
  }

  /**
   * 検定ランク情報取得
   *
   * @param ランクコード（Base64エンコード）
   */
  private async getExamRankInfo(rankCode: string) {
    const RankRepository = RepositoryFactory.get().rank;
    await RankRepository.getRankInfo(rankCode).then((response: any) => {
      if (response.status === 200) {
        this.judgementType = response.data.judgment_type;
        this.isMaintenance = response?.data?.can_pause ?? false;
      }
    }).catch(() => {
      this.isMaintenance = true;
    });
  }

  /**
   * 静的CssとJsの読み込み
   */
  private initStaticScripts() {
    const CommonCss = document.createElement('link');
    CommonCss.rel = 'stylesheet';
    CommonCss.href = '/css/common.css';
    this.$el.appendChild(CommonCss);

    const ExamResultCss = document.createElement('link');
    ExamResultCss.rel = 'stylesheet';
    ExamResultCss.href = '/exam/css/result.css';
    this.$el.appendChild(ExamResultCss);

    this.getExamConfigCss().then((cssElement: HTMLLinkElement) => {
      this.$el.appendChild(cssElement);
    });

    const CommonJs = document.createElement('script');
    CommonJs.src = '/js/common.js';
    this.$el.appendChild(CommonJs);
  }

  /**
   * 結果表示画面に遷移します。
   */
  private transitionExamResult() {
    this.$router.replace(`${this.paths.EXAM_RESULT}?entry=${this.entryCode}&result=${this.resultCode}`);
  }
}
